// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { useIncomingPayment, getFinalReceipt } from '@tectonics/prs/incoming-payment';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { getMoneyFormat } from '../../../../commons/money-format';
import { shouldRedirect } from '@tectonics/prs/incoming-payment/should-redirect';

export function Info(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = getFinalReceipt(incomingPayment);
  const decimalFormat = getMoneyFormat(incomingPayment.country);
  const formatAmount = amountToCurrencyString(decimalFormat);
  const pageIsBeingRedirected = shouldRedirect(incomingPayment);

  return (
    <Root>
      {pageIsBeingRedirected ? (
        <>
          سيتم توجيهك إلى موقع خارجي
        </>
      ) : (
        <>
          تمت الموافقة على عملية الدفع الخاصة بك بقيمة <Amount> {formatAmount(getReceiptAmountLocalTotal(receipt))} </Amount> جنيه مصري.
        </>
      )}
    </Root>
  );
}


const Root = styled.h1`
  font-family: ${props => props.theme.fontFamily.display};
  font-weight: 200;
  font-size: 1.4em;
  line-height: 1.5;
  color: ${props => props.theme.colors.primary(39)};
  background-color: ${props => props.theme.colors.gray(96)};

  @media (min-width: 840px) {
    font-size: 24px;
    color: inherit;
    background-color: transparent;
  }
`;

const Amount = styled.span`
  display: inline-block;
  font-weight: bold;
`;
